import Select from "react-select";
import {capFirstChar} from "../../utils/stringUtil";
import {listTypeSelectStyles} from "../../variables/selectStyles";
import Button from "react-bootstrap/Button";
import LoadingBars from "../../components/loadingBars";
import {useState} from "react";
import AnimeList from "../../models/AnimeList";

type Props = {
    list?: AnimeList,
    isSubmitting?: boolean,
    onSubmit: (data: {title: string, listType: string, imageUrl: string}) => void,
    submitButtonText: string
}

const ListForm = ({
    list = {
        title: "",
        listType: "",
        imageUrl: "",
        type: "",
        slug: "",
        hasAgenda: false,
        isLocked: false,
        isShared: false,
        isFeatured: false,
        user: undefined
    },
    isSubmitting = false,
    onSubmit,
    submitButtonText
}: Props) => {
    const [title, setTitle] = useState(list.title);
    const [listType, setListType] = useState(list.listType);
    const [imageUrl, setImageUrl] = useState(list.imageUrl);

    const selectOptions = [
        {value: "primary", label: "Primary"},
        {value: "secondary", label: "Secondary"},
        {value: "rewatch", label: "Re-watch"}
    ];

    return (
        <table style={{width: "100%"}}>
            <tbody>
            <tr>
                <td><label htmlFor="title">Title</label></td>
            </tr>
            <tr>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        id="title"
                        onChange={(ev) => {
                            setTitle(ev.target.value)
                        }}
                        disabled={isSubmitting}
                        value={title}
                    />
                </td>
            </tr>
            <tr>
                <td><label>Type</label></td>
            </tr>
            <tr>
                <td>
                    <Select
                        defaultValue={{value: list.type, label: capFirstChar(list.listType)}}
                        onChange={(changes) => {
                            if (changes && changes.value) {
                                setListType(changes.value)
                            }
                        }}
                        isDisabled={isSubmitting}
                        options={selectOptions}
                        styles={listTypeSelectStyles}
                    />
                </td>
            </tr>
            <tr>
                <td><label htmlFor="imageUrl">Image url</label></td>
            </tr>
            <tr>
                <td>
                    <input
                        type="text"
                        className="form-control"
                        id="imageUrl"
                        onChange={(ev) => {
                            setImageUrl(ev.target.value)
                        }}
                        disabled={isSubmitting}
                        value={imageUrl}
                    />
                </td>
            </tr>
            <tr>
                <td>
                    <Button
                        type="submit"
                        variant="success"
                        style={{float: "right", marginTop: "5px"}}
                        onClick={() => {
                            onSubmit({title, listType, imageUrl});
                        }}
                        disabled={isSubmitting}
                    >
                        {submitButtonText}
                    </Button>
                    {isSubmitting && <LoadingBars style={{float: "right", bottom: "15px", right: "20px"}}/>}
                </td>
            </tr>
            </tbody>
        </table>
    )
}

export default ListForm;
